import {combineReducers} from 'redux';
import _ from 'lodash';
import uuidv1 from 'uuid';
import {
    SET_EMBEDDED,
    SET_LOADING,
    SET_MESSAGE,
    SET_SHOW_HEADER
} from '../actions/actionTypes';
import {MESSAGE_INFO} from '../constants/index';

const initialState = {
    isLoading: false,
    message: {
        id: null,
        type: MESSAGE_INFO,
        text: null
    },
    embedded: false,
    showHeader: true,
};

const isLoading = (state = initialState.isLoading, action) => {
    switch (action.type) {
        case SET_LOADING:
            return action.isLoading;
        default:
            return state;
    }
};

const message = (state = initialState.message, action) => {
    switch (action.type) {
        case SET_MESSAGE:
            return _.assign({}, state, { 
                id: uuidv1(), 
                type: action.typeMessage, 
                text: action.text 
            });
        default:
            return state;
    }
};

const embedded = (state = initialState.embedded, action) => {
    switch (action.type) {
        case SET_EMBEDDED:
            return action.embedded ? action.embedded : false;
        default:
            return state;
    }
};

const showHeader = (state = initialState.showHeader, action) => {
    switch (action.type) {
        case SET_SHOW_HEADER:
            return action.showHeader ? action.showHeader : false;
        default:
            return state;
    }
};

const appReducer = combineReducers({
    isLoading,
    message,
    embedded,
    showHeader
});

export default appReducer;